<script>
  import ProjectGallery from './project-gallery/ProjectGallery.svelte'
  import ProjectInfo from './project-info/ProjectInfo.svelte'
  import { projectDetail } from '../../../store'
  import { PROJECT_STATUSES } from '../../../constants/constants'
  import NETWORKS from "../../../constants/network";

  let backButton = './images/back-arrow.svg'
  let verifiedIcon = './images/verified.svg'

  export let saleCardDetails, sale, token, reserve, saleData, projectTierData, project;
  let flaggedIcon = "./images/flag-icon.svg"
</script>

<div class="back-project">
  <a href="javascript:void(0)" id="back-history-page" onclick="history.back()" class="flex items-center">
    <img src={backButton} alt="backButton" />
    <p>Go Back Projects</p>
  </a>
</div>
<header class="gallery-header flex items-center">
  <div class="flex-1">
    <h2>
        {#if $projectDetail.is_verified}
            <span class="verified-wrapper">
                <img class="verified" src={verifiedIcon} alt="featured image"/>
                <small class="verified-hover">
                    <strong>Verified</strong>
                </small>
            </span>
        {/if}
        {$projectDetail.project_name ?? ""}
    </h2>
    <p>{$projectDetail.project_description ?? ""}</p>
  </div>
  <div class="ml-auto flex items-center">
    {#if saleCardDetails.chainID}
    <div class="tier-badge-btn chain-btn">
        <img src={NETWORKS[saleCardDetails.chainID].iconUrl} alt="user">
        {NETWORKS[saleCardDetails.chainID].name}
    </div>
{/if}
    {#if $projectDetail.flag}
      <span class="flagged-image flagged-detail">
            <img src={flaggedIcon} alt="flagged image">
            <small>
                <strong>This raise is void, DO NOT interact</strong>
            </small>
        </span>
    {/if}
    <div
      class={`tier-badge-btn ${$projectDetail.project_status && $projectDetail.project_status.toLowerCase()}`}>
      {$projectDetail.project_status === PROJECT_STATUSES.LIVE ? 'Live' : $projectDetail.project_status}
    </div>
    <span class="detail_tier">{$projectDetail?.wallet_tier?.tier_label ?? "Public"}</span>
  </div>
</header>
<div class="visual flex">
  {#if $projectDetail.project_cover}
    <ProjectGallery img={$projectDetail.project_cover} {projectTierData} />
  {/if}
  <ProjectInfo
    {projectTierData}
    {saleData}
    {sale}
    {reserve}
    {token}
    {saleCardDetails} />
</div>
